export default __webpack_public_path__ + "static/media/algo.4a964605.jfif";